import React from 'react'
import { Button } from '../../../components/Button/Button'
import { type OAuth2AppCredentials } from '../../../store/auth/auth'
import { CredentialField } from '../components/CredentialField'
import styles from './CreateOAuth2AppWizard.module.scss'

interface AppCreatedSuccessProps {
  credentials: OAuth2AppCredentials
  onContinue: () => void
}

export const AppCreatedSuccess: React.FC<AppCreatedSuccessProps> = ({ credentials, onContinue }) => {
  return (
    <div className={`d-flex flex-column align-items-center py-5 mx-auto ${styles['success-container']}`}>
      <div className={`d-flex align-items-center justify-content-center rounded-circle zocks-bg-color-success-background mb-3 ${styles['success-icon']}`}>
        <i className='bi bi-check-lg fs-3 zocks-text-success' />
      </div>
      <h4 className='fw-bold mb-2'>App created</h4>
      <p className='text-muted text-center mb-4'>
        Copy your <strong>Client Secret now</strong>. It will never be shown again.
      </p>

      <div className='w-100 mb-3'>
        <CredentialField label='Client ID' value={credentials.clientId} copyable />
      </div>

      {credentials.clientSecret ? (
        <div className='w-100 mb-4'>
          <CredentialField label='Client Secret (Shown once only)' value={credentials.clientSecret} copyable />
        </div>
      ) : null}

      <Button variant='primary' onClick={onContinue}>
        I've saved it, continue
      </Button>
    </div>
  )
}
